import axios from "axios";
import { ucEndpointsUrls } from "../../config/config";
import { AppDispatch } from "../../reducers";
import { getRegionsFailed, getRegionSuccess, gettingRegions } from "../../store/regions";
import { getErrorMessageFromRequest } from "../../utils/utils";

/**
 * Get Start Project product and populate Redux State.
 */
export const getPencilerRegions = () => async (dispatch: AppDispatch) => {
  dispatch(gettingRegions());
  try {
    const { data: regions } = await axios.get(ucEndpointsUrls.pencilerRegions);
    dispatch(getRegionSuccess(regions));
    return regions;
  } catch (error) {
    return dispatch(getRegionsFailed(getErrorMessageFromRequest(error)));
  }
};
